module.exports = __webpack_public_path__ + "static/media/42-3.d5e08f8c.mp3";